import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'

/**
 * Props for {@link NotesSupportingItemInput}.
 */
export type NotesSupportingItemInputProps =
  ModelProps<NotesSupportingItemInput> & { type: 'Notes' }

/**
 * Supporting item input for notes.
 */
export class NotesSupportingItemInput extends Model<NotesSupportingItemInput> {
  @observable accessor text = ''
}
